module.exports = __webpack_public_path__ + "img/gw.e1d3421a.svg";